import LAB from "@/constants/lab";

const PAYMENT_FAILURE = "Payment Failure";
const COMPLETE = "Complete";
const RECOMMENDED = "Recommended";
const DISPENSED = "Dispensed";

export default {
    data() {
        return {
            statuses: {
                COMPLETED: COMPLETE,
                PAYMENT_FAILURE: PAYMENT_FAILURE,
                RECOMMENDED: RECOMMENDED,
                DISPENSED: DISPENSED,
                PRE_ORDER_STATUS: LAB.ANTECH_STATUS.INC_PRE_ORDER
            }
        };
    },
    methods: {
        hasValue(obj) {
            if (obj === null || obj === undefined) {
                return false;
            }

            const keys = Object.keys(obj);
            return keys.length > 0;
        },
        getStatusVariant(status) {
            if (status == this.statuses.PAYMENT_FAILURE) {
                return "danger";
            } else if (
                status == this.statuses.COMPLETED ||
                status == this.statuses.DISPENSED
            ) {
                return "success";
            } else if (status == this.statuses.RECOMMENDED) {
                return "info";
            } else {
                return "secondary";
            }
        },
        hasStatus(items, status) {
            return items.some(reference => {
                return reference.statuses.some(
                    st => st.status?.label === status
                );
            });
        }
    }
}
